module.exports = __webpack_public_path__ + "img/bgp04.bcad3406.jpg";